<template>
  <form class="guidelineForm grid-12" onsubmit="return false" @submit="send">
    <div class="column wrap justify-around column-s">
      <div class="column grid-12">
        <label>Cliente</label>
        <span v-if="form.update">{{ form.nome_cliente }}</span>
        <select v-else v-model="form.id_cliente" required>
          <option v-for="(client, j) of clients_com_nome_fantasia" :value="client.id" :key="'bc' + j">
            {{ client.nome_fantasia }}
          </option>
        </select>
      </div>

      <div class="column grid-12">
        <label>Nome</label>
        <input v-model="form.nome" placeholder="Nome" required />
      </div>

      <div class="column grid-12">
        <label>Requerimentos</label>
        <input v-model="form.requerimento" placeholder="Requerimentos" required />
      </div>

      <div class="column grid-12">
        <label>Orientações</label>
        <input v-model="form.orientacao" placeholder="Orientações" required />
      </div>

      <div class="column grid-12">
        <label>RAT</label>
        <input v-model="form.rat" placeholder="RAT" required />
      </div>
    </div>

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-5">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-5" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"
        ><i class="fa fa-edit" />{{ form.update ? "ATUALIZAR" : "ADICIONAR" }}</Button
      >&nbsp;&nbsp;&nbsp;
      <Button
        v-if="form.update"
        type="button"
        @click="del"
        :loader="loader"
        layout="red-go"
        ><i class="fa fa-trash" /> APAGAR</Button
      >
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";

export default {
  name: "GuidelineForm",
  components: { Button },
  props: { form: Object },
  data() {
    return {
      loader: false,
      clients: [],
    };
  },
  beforeMount() {
    this.LOAD_CLIENTS().then(({ data }) => (this.clients = data));
  },
  computed: {
    clients_com_nome_fantasia() {
      return this.clients.filter((client) => client.nome_fantasia);
    },
  },
  methods: {
    ...mapActions("admin", ["LOAD_CLIENTS"]),
    async send() {
      this.loader = true;
      await this.form.send(this.form);
      this.loader = false;
    },
    del() {
      this.loader = true;
      this.form
        .del(this.form)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.guidelineForm
  @include form
</style>
